module.exports = __webpack_public_path__ + "static/media/own_it.50262ec2.png";